import React, { PropTypes } from 'react';
import StepperActions from '../../../generic-components/stepper-actions';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import SinglePickupDropoff from './single-pickupdropoff.jsx';
import SeasonalSections from '../../../generic-components/seasonal-sections/seasonal-sections';
import DateUtils from '../../../../../utils/date-utils';
import { isValidTime } from '../../../../../utils/validations';
import { propOr, curry, concat } from 'ramda';
import SyncSectionCheckbox from '../sync-section-checkbox';

const EditPickupDropoff = ({
  contractingPeriod,
  onRequestClose,
  onTextFieldChangeWithKeyPath,
  existingSeasons,
  contractId,
  productId,
  saveProductInfoChanges,
  data,
  saving,
  }) => {
  const pickupOrDropoffText = propOr('', 'pickupOrDropoff', data);
  const contentsData = propOr([], pickupOrDropoffText, data);
  const contentActions = { onTextFieldChangeWithKeyPath, pickupOrDropoff: pickupOrDropoffText };
  const allDateRanges = DateUtils.getFlattenedUnEmptyDates(contentsData);
  const seasonCovered = DateUtils.seasonCovered(allDateRanges, contractingPeriod);
  const onFieldChange = curry((extraPaths, value) => onTextFieldChangeWithKeyPath({ keyPath: concat(['data', pickupOrDropoffText], extraPaths), value }));
  const checkIfTimeValid = () => {
    return contentsData.some(obj =>
      obj.timeLocArray.some(timeLoc =>
        (timeLoc.time || '')
          .split(';')
          .filter(x => x && Boolean(x.trim()))
          .some(str => !isValidTime(str))));
  };
  return (
    <div>
      <SeasonalSections
        name={`${pickupOrDropoffText} information`}
        enableManualDatesEntry
        seasons={existingSeasons}
        contractingPeriod={contractingPeriod}
        varyBySeason={data.varyBySeason}
        useSeasons={data.useSeasons}
        contentsData={contentsData}
        emptyInitialContent={{ notes: '', timeLocArray: [{}] }}
        onFieldChange={onFieldChange}
        contentActions={contentActions}
        ContentNode={SinglePickupDropoff}
      />
      <br />
      <div className="flex-tc-sb" style={{ paddingLeft: '20px' }}>
        <SyncSectionCheckbox
          style={{ width: '350px' }}
          sectionInEdit={pickupOrDropoffText}
        />
        <div className="flex-center">
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            disabled={!seasonCovered || checkIfTimeValid()}
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => saveProductInfoChanges({ contractId, productId, data, updateType: 'SAVE_PICKUP_DROPOFF_INFO' })}
            secondary
          />
        </div>
      </div>
    </div>
  );
};
export default EditPickupDropoff;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/pickup-dropff/pickup-dropoff.jsx